module.exports = __webpack_public_path__ + "static/media/it.b46f8792.svg";